import Vue from 'vue';
import { RISK_CACHE_LIMIT } from '@/config/riskConfig';

export default {
    SET_CATALOG_STATUS(state, status) {
        state.catalogStatus = status;
    },
    SET_CATALOG(state, catalog) {
        state.catalog = catalog;
        state.catalogStatus = 'ready';
    },
    SET_CATALOG_ERROR(state, error) {
        state.catalogStatus = 'error';
        state.catalogError = error;
    },

    SET_INDICATOR(state, id) {
        state.indicator = id;
    },
    SET_THRESHOLD(state, { indicator, value }) {
        Vue.set(state.thresholdByIndicator, indicator, value);
    },
    SET_OP(state, { indicator, value }) {
        Vue.set(state.opByIndicator, indicator, value);
    },
    SET_CATEGORY(state, { indicator, value }) {
        Vue.set(state.categoryByIndicator, indicator, value);
    },
    SET_MIN_HOURS(state, { indicator, value }) {
        Vue.set(state.minHoursByIndicator, indicator, value);
    },

    SET_STATUS(state, status) {
        state.status = status;
    },
    SET_DATA(state, data) {
        state.data = data;
        state.error = null;
    },
    SET_ERROR(state, error) {
        state.error = error;
        state.data = null;
    },
    SET_LAST_PARAMS(state, params) {
        state.lastParams = params;
    },

    CACHE_PUT(state, { key, entry }) {
        Vue.set(state.cache, key, entry);
        const idx = state.cacheOrder.indexOf(key);
        if (idx !== -1) state.cacheOrder.splice(idx, 1);
        state.cacheOrder.push(key);
        while (state.cacheOrder.length > RISK_CACHE_LIMIT) {
            const oldest = state.cacheOrder.shift();
            Vue.delete(state.cache, oldest);
        }
    },
};
